import Button from "components/ui/Button";
import ForbiddenImage from "images/403.svg";
import { useNavigate } from "react-router-dom";
import Page from "components/page/PageContent/PageContent";

import { routes } from "pages/routes";
import "./style.css";
import { useTranslation } from "react-i18next";

export const ForbiddenPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleDashboard = () => {
    navigate(routes.root.path());
  };

  const handleCatalog = () => {
    navigate(routes.libraryRoot.path());
  };

  return (
    <Page name="error">
      <div className="error-container">
        <div className="error-content-container">
          <div className="error-conatiner-right">
            <span className="error-heading">{t("Errors.forbidden.headline")}</span>
            <span className="error-title">{t("Errors.forbidden.title")}</span>
            <span className="error-description">{t("Errors.forbidden.description")}</span>
            <div className="error-button-container">
              <Button onClick={handleCatalog}>{t("Errors.actions.browseCatalog")}</Button>
              <Button variant="secondary" onClick={handleDashboard}>
                {t("Errors.actions.goToDashboard")}
              </Button>
            </div>
          </div>
          <div className="error-conatiner-left">
            <img src={ForbiddenImage} width={419} alt="" />
          </div>
        </div>
      </div>
    </Page>
  );
};
